var map = {
	"./decidim/avatar-multiuser.png": 6004,
	"./decidim/brands/google.svg": 32539,
	"./decidim/cc-badge.png": 88790,
	"./decidim/decidim-logo.svg": 38998,
	"./decidim/default-avatar.svg": 56530,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 1974,
	"./decidim/icons.svg": 42981,
	"./decidim/pattern.png": 14610,
	"./decidim/placeholder-card-g.svg": 6847,
	"./decidim/placeholder-card-l.svg": 87108,
	"./decidim/placeholder.jpg": 30267,
	"./decidim/remixicon.symbol.svg": 32627,
	"./decidim/vendor/leaflet/layers-2x.png": 82838,
	"./decidim/vendor/leaflet/layers.png": 19949,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 39092,
	"./decidim/vendor/leaflet/marker-icon.png": 48147,
	"./decidim/vendor/leaflet/marker-shadow.png": 94792,
	"./decidim/vendor/social-share-button/douban.svg": 58338,
	"./decidim/vendor/social-share-button/email.svg": 20927,
	"./decidim/vendor/social-share-button/facebook.svg": 71457,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 62195,
	"./decidim/vendor/social-share-button/hacker_news.svg": 7475,
	"./decidim/vendor/social-share-button/linkedin.svg": 72687,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 58376,
	"./decidim/vendor/social-share-button/pinterest.svg": 11921,
	"./decidim/vendor/social-share-button/reddit.svg": 95425,
	"./decidim/vendor/social-share-button/telegram.svg": 19320,
	"./decidim/vendor/social-share-button/tumblr.svg": 93519,
	"./decidim/vendor/social-share-button/twitter.svg": 45998,
	"./decidim/vendor/social-share-button/vkontakte.svg": 93488,
	"./decidim/vendor/social-share-button/wechat.svg": 78363,
	"./decidim/vendor/social-share-button/whatsapp.svg": 57907,
	"./decidim/vendor/social-share-button/x.svg": 21719,
	"./decidim/vendor/social-share-button/xing.svg": 27073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57839;